export default __webpack_public_path__ + "static/media/img_24.d7a2fc4e.JPG";